// RejectServiceOrderReqPage.js
import React, { useEffect, useState } from "react";
import { FaTimes } from "react-icons/fa";
import "../../invite.css";

const RejectServiceOrderReqPage = () => {
  const [loading, setLoading] = useState(true);
  const [success, setSuccess] = useState(null);
  const BASE_URL = process.env.REACT_APP_API_URL;

  useEffect(() => {
    const mainId = new URLSearchParams(window.location.search).get("pvid");

    const handleReject = async () => {
      if (!mainId) {
        console.warn("❌ Missing mainId in query string");
        setSuccess(false);
        setLoading(false);
        return;
      }

      try {
        // 🔹 Step 2: Send rejection request with statusID = 2
        try {
          const response = await fetch(`${BASE_URL}/WorkOrderRequest/Approve_WorkOrderRequest`, {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({
              workOrderRequestID: parseInt(mainId),
              approveByID: 18,
              workStageID: 0,
              statusID: 2, // --> 2 = rejection
            }),
          });

          if (!response.ok) throw new Error(`Rejection failed with status ${response.status}`);
          setSuccess(true);
        } catch (err) {
          throw new Error("Failed to reject Additional Item: " + err.message);
        }
      } catch (error) {
        console.error("❌ Error in handleReject:", error);
        setSuccess(false);
      } finally {
        setLoading(false);
      }
    };

    handleReject();
  }, [BASE_URL]);

  if (loading) {
    return (
      <div className="center-screen">
        <div className="loader-container" aria-live="polite">
          <img
            src="/Montdor_1.png"
            alt="Company Logo"
            className="company-logo"
            onError={(e) => (e.target.style.display = "none")}
          />
          <div className="spinner"></div>
          <p className="loader-text">Processing your request...</p>
        </div>
      </div>
    );
  }

  return (
    <div className="center-screen" style={{ backgroundColor: "#2c2139" }}>
      <div className="card-box">
        {success ? (
          <>
            <div className="icon"><FaTimes size={48} color="#e74c3c" /></div>
            <h2 className="card-title">Rejected</h2>
            <p className="card-msg">Additional Item has been Rejected.</p>
          </>
        ) : (
          <>
            <div className="icon"><FaTimes size={48} color="#888" /></div>
            <h2 className="card-title">Error</h2>
            <p className="card-msg">Unable to reject Additional Item.</p>
          </>
        )}
      </div>
    </div>
  );
};

export default RejectServiceOrderReqPage;